import { useCallback, useEffect, useState } from "react";
import { nextIndex, prevIndex } from "./carouselTapNav";

/**
 * Shared index state for the within-post media carousel. Owns the current
 * slide and forward/back navigation (wraparound), so `ClientFeedPost` and
 * `PostCard` drive their carousels through one code path.
 */
export function useCarouselTapNav(count: number) {
  const [index, setIndex] = useState(0);

  // Keep the index in range if the media set shrinks under the cursor.
  useEffect(() => {
    setIndex((i) => (i >= count ? Math.max(0, count - 1) : i));
  }, [count]);

  const goNext = useCallback(() => setIndex((i) => nextIndex(i, count)), [count]);
  const goPrev = useCallback(() => setIndex((i) => prevIndex(i, count)), [count]);

  return { index, setIndex, goPrev, goNext };
}
